var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from "classnames";
import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { IconChevronDown, IconChevronRight } from "../../icons";
import Typography from "../Typography";
export var Panel = function (props) {
    var _a, _b;
    var _c = props.open, open = _c === void 0 ? false : _c, children = props.children, header = props.header, _d = props.expandIconPosition, expandIconPosition = _d === void 0 ? "left" : _d, _e = props.className, className = _e === void 0 ? "" : _e, _f = props.headerClassName, headerClassName = _f === void 0 ? "" : _f, expandIcon = props.expandIcon, onClickOpen = props.onClickOpen;
    var _g = useState(open), isOpen = _g[0], setIsOpen = _g[1];
    var _h = useState(open ? undefined : 0), height = _h[0], setHeight = _h[1];
    var ref = useRef(null);
    var classNames = classnames((_a = {},
        _a["mex-collapse-panel__wrapper"] = true,
        _a[className] = className,
        _a));
    var handleOpen = function () {
        setIsOpen(function (prev) { return !prev; });
        if (onClickOpen)
            onClickOpen();
    };
    useEffect(function () {
        setIsOpen(open);
    }, [open]);
    useEffect(function () {
        if (!height || !isOpen || !ref.current)
            return undefined;
        var resizeObserver = new ResizeObserver(function (el) {
            setHeight(el[0].contentRect.height);
        });
        resizeObserver.observe(ref.current);
        return function () {
            resizeObserver.disconnect();
        };
    }, [height, isOpen]);
    useEffect(function () {
        var _a;
        if (isOpen)
            setHeight((_a = ref.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().height);
        else
            setHeight(0);
    }, [isOpen]);
    var headerClassNames = classnames((_b = {},
        _b["mex-collapse-panel__header"] = true,
        _b[headerClassName] = headerClassName,
        _b));
    return (_jsx(React.Fragment, { children: _jsxs("div", __assign({ className: classNames }, { children: [_jsxs("div", __assign({ className: headerClassNames }, { children: [_jsx("div", __assign({ className: "mex-collapse__icon-button", onClick: handleOpen }, { children: _jsx("div", __assign({ style: {
                                    float: expandIconPosition === "left" ? "left" : "right",
                                } }, { children: expandIcon ? expandIcon(isOpen) : isOpen ? _jsx(IconChevronDown, {}) : _jsx(IconChevronRight, {}) })) })), _jsx(Typography, __assign({ variant: "heading05" }, { children: header }))] })), _jsx("div", __assign({ className: "mex-collapse__content", style: { height: height } }, { children: _jsx("div", __assign({ ref: ref }, { children: _jsx("div", __assign({ className: "mex-collapse__content-padding" }, { children: _jsx(Typography, __assign({ variant: "body01Regular" }, { children: children })) })) })) }))] })) }));
};
Panel.propTypes = {
    header: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    open: PropTypes.bool,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
    expandIconPosition: PropTypes.oneOf(["left", "right"]),
    onClickOpen: PropTypes.func,
    className: PropTypes.string,
    headerClassName: PropTypes.string,
    expandIcon: PropTypes.func,
};
Panel.defaultProps = {
    expandIconPosition: "left",
};
export default Panel;
